var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49145 8.60538C6.25674 8.69673 6.94305 8.77541 7.71442 8.49995C8.46296 8.23264 9.13139 8.29881 9.86961 8.38644C9.85886 8.35264 9.84784 8.31843 9.83653 8.28383C9.58201 7.50473 9.22515 6.63898 8.8293 5.83252C8.45058 5.06095 8.05817 4.3886 7.71429 3.91498C7.37042 4.3886 6.97801 5.06095 6.59929 5.83252C6.20344 6.63898 5.84658 7.50473 5.59206 8.28383C5.55567 8.39522 5.52217 8.50246 5.49145 8.60538ZM8.19167 3.37338C8.19157 3.37417 8.18368 3.38044 8.16834 3.38981C8.1841 3.37726 8.19177 3.37258 8.19167 3.37338ZM7.26025 3.38981C7.24491 3.38044 7.23702 3.37417 7.23692 3.37338C7.23681 3.37258 7.24449 3.37726 7.26025 3.38981ZM11.7143 10C11.7143 12.2091 9.92343 14 7.71429 14C5.50516 14 3.71429 12.2091 3.71429 10C3.71429 7.79086 6.48353 2 7.71429 2C8.94506 2 11.7143 7.79086 11.7143 10Z",
    fill: "#31C1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.4d4984f2c8f366efc1b7708871b33cce.svg";
export { ForwardRef as ReactComponent };